import type { CountryLanguages } from '~/types/countryLanguages';
import type { StoryblokConfigSlug } from '~/types/storyblokConfigSlug';

export function resolveSectionPath(
    config: StoryblokConfigSlug,
    language: string,
    countryLanguages: CountryLanguages
): string | null {
    const countryConfig = countryLanguages[config.country];
    if (!countryConfig?.availableLanguages.includes(language)) return null;

    if (language === countryConfig.defaultLanguage) {
        return config.slug;
    }

    const translatedSlug = config.translatedSlugs?.[language];
    if (translatedSlug?.published === false) {
        return null;
    }

    return translatedSlug?.path ?? config.slug;
}
